import { ContactForm } from "./ContactForm";
import { Icon } from "./Icons";

type Props = {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  initialMessage?: string;
};

export function ContactModal({
  open,
  onClose,
  title = "Got a tag script doing too much?",
  subtitle = "Tell us about the workload and we'll sanity-check the fit.",
  initialMessage,
}: Props) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(28,26,22,.45)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 8,
          maxWidth: 520,
          width: "100%",
          padding: "32px 36px 28px",
          boxShadow: "0 20px 60px rgba(0,0,0,.25)",
          position: "relative",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 14,
            right: 14,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "var(--ink-4)",
          }}
        >
          <Icon.X />
        </button>
        <div style={{ fontSize: 15, color: "var(--ink)", fontWeight: 600, marginBottom: 4 }}>
          {title}
        </div>
        <div style={{ fontSize: 13, color: "var(--ink-3)", marginBottom: 16 }}>
          {subtitle}
        </div>
        <ContactForm initialMessage={initialMessage} />
      </div>
    </div>
  );
}
